module.exports = __webpack_public_path__ + "assets/img/BusinessDataMetrics@2x.fe14db27.png";